import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { methodConfig } from '../../config/cashier.config';
import { EmitterService } from '../../../services/emitter.service';

@Component({
  selector: 'app-payment-details',
  templateUrl: './payment-details.component.html',
  styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent implements OnInit {
  public form: FormGroup;
 
  formData;
  fields:any;
  oneLineInputsData:any;
  methodConfig = methodConfig;
  isNewFormEnabled = true;
 
  selectedPaymentMethod;
  isFormValidationRequired= false;
 
  constructor(private emitterService:EmitterService) {
    this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.fields))
    })
    this.emitterService.addNewCardClick$.subscribe((state)=>{
      this.isNewFormEnabled = state;
    })
   }

  ngOnInit(): void {
    
    this.emitterService.onChangePaymentMethod$.subscribe((newMethod:any) => {
      this.fields = undefined;
      this.oneLineInputsData = undefined;
      let methodName = newMethod.name;
      if(methodName.includes('-')){
         methodName = methodName.split('-')[0];
      }
      setTimeout(()=>{
        this.selectedPaymentMethod = newMethod;
        this.fields = this.methodConfig[methodName]?.inputs;
        this.oneLineInputsData = this.methodConfig[methodName]?.oneLineFields;
        if(this.fields && this.oneLineInputsData && this.oneLineInputsData.length){
           this.isFormValidationRequired = true;
        }else{
          this.isFormValidationRequired = false;
        }
        this.emitterService.broadCastFormValidationStatus(this.isFormValidationRequired)
      })
    });
  }
  updateFormData(e){
    this.formData = e;
  }
  getFields() {
    return this.fields;
  }
}
